export const NEW_NOTIFICATION = 'NEW_NOTIFICATION'; 
export const NEW_QUOTA_MESSAGE = 'NEW_QUOTA_MESSAGE'; 
export const ASSISTANT_INSIGHT = 'ASSISTANT_INSIGHT';
export const NEW_CONNECTION = 'NEW_CONNECTION';
export const NEW_INTERCONNECTION = 'NEW_INTERCONNECTION';
export const NEW_MESSAGE = 'NEW_MESSAGE';
export const TICKET_ASSIGN = 'TICKET_ASSIGN';
export const PUSHER_UPDATE_MEMBER = 'PUSHER_UPDATE_MEMBER';
